<!-- App.vue -->
<template>
  <div id="app">
    <div v-if="loading" class="spinner">
      <!-- Preloader Spinner -->
      <div class="loader"></div>
    </div>
    <div v-else>
      <router-view />
    </div>
  </div>
</template>

<script>
import axios from 'axios';

export default {
  name: 'App',
  data() {
    return {
      loading: true, // Initially loading is true
    };
  },
  mounted() {
    const keysToCheck = [
      'carrier_changes',
      'coverage_changes',
      'driver_changes',
      'equipment_changes'
    ];

    keysToCheck.forEach(key => {
      if (localStorage.getItem(key)) {
        localStorage.removeItem(key);
      }
    });

    // Start with the first API call
    this.fetchGuidData();

  },
  methods: {
    // step 1: Fetching data using GUID
    fetchGuidData() {
      const urlParams = new URLSearchParams(window.location.search);
      const guid = urlParams.get('guid'); // Fetching GUID from URL params

      if (!guid) {
        console.error('GUID parameter is missing in the URL');
        this.loading = false;
        return;
      }

      // Create the URL with the GUID as a query parameter
      const apiUrl = '/api/ClientRenewal/getguid/' + guid;
      axios.get(apiUrl)
        .then(response => {
          const { lookupCode, expirationDate } = response.data;
          // Step 2: Fetch and store data
          this.fetchAndStoreData(lookupCode, expirationDate);
          this.fetchCompletionStatus(guid);
          localStorage.setItem('guid', guid);
        })
        .catch(error => {
          console.error('Error fetching GUID data:', error);
          this.loading = false;
        });
    },

    // Phase 2: Using lookupCode and expirationDate to fetch more data
    fetchAndStoreData(lookupCode, expirationDate) {
      if (!lookupCode || !expirationDate) {
        console.error('Missing required data for second API call');
        this.loading = false;
        return;
      }

      const requestBody = {
        uniqEntity: "0",
        expirationDate: expirationDate,
        LookupCode: lookupCode
      };
      const config = {
        headers: {
          'Content-Type': 'application/json'
        }
      };

      // Phase 2: Make the POST request
      axios.post('/api/clientrenewal/getderuloroot', requestBody, config)
        .then(response => {
          // Store the data in localStorage
          localStorage.setItem('deruloData', JSON.stringify(response.data));
          console.log('Phase 2 data fetched and stored:', response.data);
          this.loading = false;
        })
        .catch(error => {
          console.error('Error fetching detailed data:', error);
          this.loading = false;
        });
    },
    fetchCompletionStatus(guid) {
      const config = {
        headers: {
          'Content-Type': 'application/json'
        }
      };

      axios.post('/api/ClientRenewal/getCompletionStatus', { Id: guid }, config)
        .then(response => {
          if (Object.keys(response.data).length === 0) {
            this.insertCompletionStatus(guid)
          } else {
            this.updateCompletionStatus(guid)
          }

        })
        .catch(error => {
          console.error('Error fetching detailed data:', error);
        });
    },
    insertCompletionStatus(guid) {     
      const requestBody = {
        Id: guid,
        status: 1
      };
      const config = {
        headers: {
          'Content-Type': 'application/json'
        }
      };

      axios.post('/api/clientrenewal/insertCompletionStatus', requestBody, config)
        .then(response => {
          console.log('Insert successful:', response.data);
        })
        .catch(error => {
          console.error('Error fetching detailed data:', error);
        });
    },
    updateCompletionStatus(guid) { 
        const requestBody = {
          Id: guid,
          status: 1
        };
        console.log(requestBody);
        const config = {
          headers: {
            'Content-Type': 'application/json'
          }
        };

        axios.put('/api/clientrenewal/updateCompletionStatus', requestBody, config)
        .then(response => {
          console.log('Update successful:', response.data);
        })
        .catch(error => {
        console.error('Error updating completion status:', error);
    });
    }
  }
}
</script>
<style>
/* Global styles */
:root {
  --font-main: 'Montserrat', sans-serif;
}

body {
  font-family: var(--font-main);
  margin: 0;
  padding: 0;
  background-color: #f4f4f4;
}

button,
.changes-input {
  font-family: var(--font-main);
}

.changes-input::placeholder {
  /* Chrome, Firefox, Opera, Safari 10.1+ */
  font-family: var(--font-main);
  opacity: 1;
  /* Firefox */
}

#app {
  text-align: center;
}

header {
  background-color: #ffffff;
  border-bottom: 2px solid #e0e0e0;
}

.logo-container {
  text-align: left;
  padding: 20px 0;
}

.logo {
  height: 40px;
}

.header-content {
  text-align: left;
  padding: 10px 13px;
}

.confirmation-text {
  font-size: 18px;
  color: #333;
  margin: 0;
}

.progress-container {
  background-color: #004d40;
  padding: 20px 0;
}

.progress-bar {
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto;
  width: fit-content;
}

.step {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background-color: #e0e0e0;
  color: #004d40;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 10px;
  font-size: 18px;
  position: relative;
}

.step.completed {
  background-color: #8bc34a;
  color: #fff;
}

.line {
  height: 2px;
  width: 50px;
  background-color: #e0e0e0;
}

.header-bottom {
  padding: 10px 0;
  background-color: #ffffff;
  border-top: 1px solid #e0e0e0;
}

.header-bottom h2 {
  margin: 0;
  font-size: 24px;
  color: #333;
}


/* Media queries for larger screens */
@media (min-width: 600px) {

  .logo {
    height: 40px;
  }

  .header-content {
    text-align: left;
    padding: 10px 13px;
  }

  .confirmation-text {
    font-size: 18px;
  }

  .progress-container {
    padding: 20px 0;
  }

  .progress-bar {
    flex-wrap: nowrap;
  }

  .step {
    width: 40px;
    height: 40px;
    margin: 0 10px;
    font-size: 18px;
  }

  .line {
    width: 50px;
  }

  .header-bottom h2 {
    font-size: 24px;
  }
}

/* Media queries for smaller screens */
@media (max-width: 600px) {
  .confirmation-text {
    font-size: 12px;
  }

  .header-bottom h2 {
    font-size: 16px;
  }

  .step {
    width: 30px;
    height: 30px;
    font-size: 12px;
  }

  .line {
    width: 20px;
  }
}

button {
  padding: 10px 20px;
  margin: 0 10px;
  border: none;
  border-radius: 5px;
  cursor: pointer;
  font-size: 16px;
}

.request-changes {
  background-color: #004d40;
  color: white;
}

.info-correct {
  background-color: #72933d;
  color: black;
}

.done-button {
  background-color: #72933d;
  color: black;
  padding: 10px 20px;
  border: none;
  border-radius: 7px;
  cursor: pointer;
  font-size: 16px;
  width: 90%;
  margin-bottom: 20px;
}

.spinner {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 999;
}

.loader {
  border: 16px solid #f3f3f3;
  /* Light grey */
  border-top: 16px solid #3498db;
  /* Blue */
  border-radius: 50%;
  width: 120px;
  height: 120px;
  animation: spin 2s linear infinite;
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(360deg);
  }
}

.backDiv:hover {
  cursor: pointer;
}
</style>
